import ActionConstants from '../constants/ActionConstants';

const clearState = () => ({
  type: ActionConstants.CLEAR_STATE,
});

export default clearState;
